import LegalPageLayout, {
  LegalH2,
  LegalLink,
} from '@/components/LegalPageLayout';

const RefundPolicy = () => (
  <LegalPageLayout
    title="Refund Policy"
    effectiveDate="06 April 2026"
    version="1.0"
  >
    <p style={{ marginBottom: 16 }}>
      Published URL:{' '}
      <LegalLink href="https://shareshack.co.uk/refund-policy">
        https://shareshack.co.uk/refund-policy
      </LegalLink>
    </p>

    {/* ── 1. How Billing Works ─────────────────────────────────────────── */}
    <LegalH2>1. How Billing Works</LegalH2>
    <p>
      Share Shack subscriptions are billed through Stripe, not through the Apple
      App Store or Google Play Store. This means refund requests come to us
      directly. Apple and Google cannot process refunds for Share Shack
      subscriptions.
    </p>

    {/* ── 2. Cancellation ──────────────────────────────────────────────── */}
    <LegalH2>2. Cancellation</LegalH2>
    <p>
      You can cancel your subscription at any time from the Account screen in the
      app. Cancellation takes effect at the end of your current billing period.
      You keep full access to paid features until then. We do not offer partial
      refunds for unused time within a billing period.
    </p>

    {/* ── 3. 14-Day Cooling-Off Period ─────────────────────────────────── */}
    <LegalH2>3. 14-Day Cooling-Off Period</LegalH2>
    <p>
      Under UK consumer law (Consumer Contracts Regulations 2013), you are
      entitled to cancel a digital subscription within 14 days of purchase. If
      you subscribed within the last 14 days, you may request a full refund.
    </p>
    <p style={{ marginTop: 8 }}>
      To request a cooling-off refund, email{' '}
      <LegalLink href="mailto:support@shareshack.co.uk">
        support@shareshack.co.uk
      </LegalLink>{' '}
      with the email address associated with your Share Shack account. We will
      process the refund within 5 working days.
    </p>

    {/* ── 4. Refunds Outside the Cooling-Off Period ────────────────────── */}
    <LegalH2>4. Refunds Outside the Cooling-Off Period</LegalH2>
    <p>
      We do not offer routine refunds after 14 days. We will consider refund
      requests on a case-by-case basis in the following circumstances:
    </p>
    <ul style={{ marginTop: 8, marginBottom: 12, paddingLeft: 24 }}>
      <li>
        You were charged after cancelling and the cancellation did not process
        correctly.
      </li>
      <li>
        You experienced a technical issue that prevented you from using paid
        features for a significant portion of your billing period.
      </li>
      <li>
        You were charged in error (for example, a duplicate payment).
      </li>
    </ul>
    <p>
      Email{' '}
      <LegalLink href="mailto:support@shareshack.co.uk">
        support@shareshack.co.uk
      </LegalLink>{' '}
      with details and we will respond within 48 hours.
    </p>

    {/* ── 5. Annual Subscriptions ──────────────────────────────────────── */}
    <LegalH2>5. Annual Subscriptions</LegalH2>
    <p>
      Annual subscriptions follow the same 14-day cooling-off policy described in
      Section 3. After 14 days, annual subscriptions are non-refundable. You can
      cancel at any time to prevent renewal, and your access continues until the
      end of the paid year.
    </p>

    {/* ── 6. How to Request a Refund ───────────────────────────────────── */}
    <LegalH2>6. How to Request a Refund</LegalH2>
    <p>
      Email{' '}
      <LegalLink href="mailto:support@shareshack.co.uk">
        support@shareshack.co.uk
      </LegalLink>{' '}
      with the following information:
    </p>
    <ul style={{ marginTop: 8, marginBottom: 12, paddingLeft: 24 }}>
      <li>The email address on your Share Shack account.</li>
      <li>Your reason for the refund request.</li>
      <li>The approximate date of the charge.</li>
    </ul>

    {/* ── 7. Apple App Store and Google Play Store ──────────────────────── */}
    <LegalH2>7. Apple App Store and Google Play Store</LegalH2>
    <p>
      Share Shack subscriptions are not processed through the App Store or Play
      Store. Apple and Google are unable to issue refunds for Share Shack. If you
      have contacted Apple or Google about a refund, please contact us directly
      at{' '}
      <LegalLink href="mailto:support@shareshack.co.uk">
        support@shareshack.co.uk
      </LegalLink>{' '}
      and we will assist you.
    </p>

    {/* ── 8. Changes to This Policy ────────────────────────────────────── */}
    <LegalH2>8. Changes to This Policy</LegalH2>
    <p>
      We may update this refund policy from time to time. The current version
      will always be available at the URL listed at the top of this document.
      Material changes will be communicated via the app or email.
    </p>

    {/* ── Contact ──────────────────────────────────────────────────────── */}
    <LegalH2>Contact</LegalH2>
    <p>
      Email:{' '}
      <LegalLink href="mailto:support@shareshack.co.uk">
        support@shareshack.co.uk
      </LegalLink>
      <br />
      Website:{' '}
      <LegalLink href="https://shareshack.co.uk">shareshack.co.uk</LegalLink>
    </p>
  </LegalPageLayout>
);

export default RefundPolicy;
